<template>
  <v-app>
    <v-main>
      <router-view />
    </v-main>
    <app-footer></app-footer>
  </v-app>
</template>

<style>

  * {
    hyphens: auto;
    font-family: "Montserrat", sans-serif;
  }

</style>

<script>
import AppFooter from "./components/AppFooter";



export default {
  name: "App",

  components: {
    AppFooter,
    
  },

  data: () => ({
    //
  }),
};
</script>
